import axiosInstance from '../../axios-config';

const getAssignedQuestionnairesUrl = '/api/patients/{0}/assignedquestionnaires';
const getAssignedNewCountUrl = '/api/patients/{0}/assignedquestionnaires/newcount';
const getQuestionnaireDetailsUrl = '/api/patients/{0}/assignedquestionnaires/{1}';
const submitQuestionnaireUrl = '/api/patients/{0}/assignedquestionnaires/{1}';
const declineQuestionnaireUrl = '/api/patients/{0}/assignedquestionnaires/declinequestionnaire';
const getHistoricalQuestionnairesUrl = '/api/patients/{0}/assignedquestionnaires/history';
const getHistoricalQuestionnaireDetailsUrl = '/api/patients/{0}/assignedquestionnaires/history/{1}';
const getKioskQuestionnairesUrl = 'api/kiosk/questionnaires?dueDate={dueDate}';

export const getQuestionnaires = (patientId) => (
  axiosInstance.get(getAssignedQuestionnairesUrl.replace('{0}', patientId))
);

export const getNewQuestionnairesCount = (patientId) => (
  axiosInstance.get(getAssignedNewCountUrl.replace('{0}', patientId))
);

export const getQuestionnaireDetails = (patientId, questionnaireId) => (
  axiosInstance.get(getQuestionnaireDetailsUrl
    .replace('{0}', patientId)
    .replace('{1}', questionnaireId))
);

export const submitQuestionnaire = (patientId, assignedQuestionnare) => (
  axiosInstance.put(submitQuestionnaireUrl.replace('{0}', patientId)
    .replace('{1}', assignedQuestionnare.assignedQuestionnaireId),
  assignedQuestionnare)
);

export const declineQuestionnaire = (patientId, assignedQuestionnare) => (
  axiosInstance.put(declineQuestionnaireUrl.replace('{0}', patientId),
    assignedQuestionnare)
);

export const getHistoricalQuestionnaires = (patientId) => (
  axiosInstance.get(getHistoricalQuestionnairesUrl.replace('{0}', patientId))
);

export const getHistoricalQuestionnaireDetails = (patientId, questionnaireId) => (
  axiosInstance.get(getHistoricalQuestionnaireDetailsUrl
    .replace('{0}', patientId)
    .replace('{1}', questionnaireId))
);

export const getKioskQuestionnaires = (dueDate) =>
  axiosInstance.get(getKioskQuestionnairesUrl.replace('{dueDate}', dueDate.format('YYYY-MM-D')));